module.exports = __webpack_public_path__ + "static/img/4.cb4d0b7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/3/zh/4.png
// module id = 9f3O
// module chunks = 0